import {  useState } from "react";
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../../utils/dashboardUtils.js";
import NewFilterBar from "./components/NewFilter.js";
import SaleDataComponent from "./components/SaleData.js";
import QuaterlyPerformance from "./components/QuaterlyPerformance.js";
import MonthlyPerformance from "./components/MonthlyPerformance.tsx";
import SalesTrendHeader from "../SalesTrendHeader.tsx";
import { API_BASE_URL } from "../../config/config.js";


function SalesTrendDashboard() {
  const [refreshTime, setRefreshTime] = useState(null);
  const [userLoaction, setuserLocation] = useState(null);
  const [headerUsername, setheaderUsername] = useState(null);

  useTokenFromQuery("/app/salestrend_dashboard");
  useFetchUserDetails(setuserLocation, setheaderUsername, setRefreshTime, API_BASE_URL , "SalesTrendDashboard");
  useResetRefreshTime(setRefreshTime);
  const user_id = getUserIdFromToken();
  
  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="Sales Trend Dashboard"
          userName={headerUsername}
          location={userLoaction}
          refreshTime={refreshTime}
        />
        <div className="new-filter-bar-sticky">
          <NewFilterBar
            user_id={user_id}
            apiEndpoint="Dashboard/SalesTrendDashboard"
          />
        </div>
        <SaleDataComponent />
        <QuaterlyPerformance />
        <MonthlyPerformance />
      </div>
    </div>
  );
}

export default SalesTrendDashboard;
